import React, {Component} from 'react';
import DealroomFinStr from "./DealroomFinStr";
import {connect} from "react-redux";
import ScenarioFinStr from './ScenarioFinStr';
import {Button} from "reactstrap";
import {preCreatingFinStrScenarioValues} from "./ScenarioFinStr/helpers";
import {validationCheck} from "../../helpers";
import {
  createFinancialStructureScenario,
  getScenarioFinStrs, getDealroomFinStrScenarios,
  setDealRoomFinSchemaErrorsObjectsCreating,
  editDealroomFinStrScenario
} from "../../../store/actions";
import {NotificationManager} from "react-notifications";



class DealroomFinStructures extends Component {
  state = {
    scenarioFinStrData: null,
  };

  saveScenario = () => {
    const {scenarioFinStrData} = this.state;
    const {dealroomFinStr,
      dealroomFinSchemaErrors,
      dealroomId,
      createFinancialStructureScenario,
      getScenarioFinStrs,
      name,
      NotificationManager,
      setDealRoomFinSchemaErrorsObjectsCreating,
      removeChoosenProjects,dealroomFinStrScenariosLength,
      getDealroomFinStrScenarios,changeTab} = this.props;

    if (!validationCheck(dealroomFinSchemaErrors[0])) {
      const result = {
        name,
        financial_structure: dealroomFinStr[0].id,
        waterfall_items: [],
      };
      result.waterfall_items = preCreatingFinStrScenarioValues(scenarioFinStrData, dealroomFinStr[0]);
      createFinancialStructureScenario(result).then((response) => {
        getScenarioFinStrs(response.data.detail).then((res) => {
          setDealRoomFinSchemaErrorsObjectsCreating(res.payload.length);
          NotificationManager.success('Scenario successfuly saved', "", 5000)
        });
        getDealroomFinStrScenarios(dealroomId).then(()=> {
          changeTab(dealroomFinStrScenariosLength,'activeFinStrTab')

        });
        removeChoosenProjects('onFinStrcheckbox', -1);
      })
    }

  };

  editScenario = () => {
    const {scenarioFinStrData} = this.state;
    const {dealroomFinStr,editDealroomFinStrScenario,dealroomFinSchemaErrors,choosenFinStrScenarioData} = this.props;

    if (!validationCheck(dealroomFinSchemaErrors[0])) {
      const result = {
        name: choosenFinStrScenarioData.name,
        financial_structure: dealroomFinStr[0].id,
        waterfall_items: [],
      };
      result.waterfall_items = preCreatingFinStrScenarioValues(scenarioFinStrData, dealroomFinStr[0]);
      editDealroomFinStrScenario(result,choosenFinStrScenarioData.id).then(() => {
        NotificationManager.success('Scenario successfuly edited', "", 5000)
      })
    }

  };

  scenarioFinStrDataChange = (data) => {
    this.setState({scenarioFinStrData: data})
  };

  render() {
    const {dealroomFinStr, onFinStrChoose, onFinStrcheckbox, scenarioFinStrShow, newFinStrScenarioCreating, removeChoosenProjects} = this.props;
    return (
      <div>
        <h3>Finanicical Structures</h3>
        {dealroomFinStr && dealroomFinStr.map((financial_structure, i) => {
          return (
            <div key={i}
                 style={{
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'space-between'
                 }}>
              {!scenarioFinStrShow ? <DealroomFinStr financial_structure={financial_structure}
                                                     onFinStrChoose={onFinStrChoose}
                                                     removeChoosenProjects={removeChoosenProjects}
                                                     onFinStrcheckbox={onFinStrcheckbox}
                                                     finStrIndex={i}/>
                : <ScenarioFinStr financial_structure={financial_structure}
                                  scenarioFinStrDataChange={this.scenarioFinStrDataChange}
                                  finStrIndex={i}/>
              }
            </div>
          )
        })}
        {scenarioFinStrShow &&
        (newFinStrScenarioCreating ?
          <Button color="primary" style={{float: 'right'}} onClick={this.saveScenario}> SAVE SCENARIO </Button>
          : <Button color="primary" style={{float: 'right'}} onClick={this.editScenario}> EDIT SCENARIO</Button>)}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    scenarioFinStrShow: state.dealroom.scenarioFinStrShow,
    newFinStrScenarioCreating: state.dealroom.newFinStrScenarioCreating,
    dealroomFinSchemaErrors: state.financicalSchemas.dealroomFinSchemaErrors,
    choosenFinStrScenarioData: state.dealroom.choosenFinStrScenarioData,
    name: state.schemas.name
  }
};

export default connect(mapStateToProps, {
  createFinancialStructureScenario,
  editDealroomFinStrScenario,
  getScenarioFinStrs,
  setDealRoomFinSchemaErrorsObjectsCreating,
  getDealroomFinStrScenarios
})(DealroomFinStructures);


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomFinStructures.js